// material-ui
import { useTheme, styled } from '@mui/material/styles';
import { Divider, Grid, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Typography } from '@mui/material';
import { Notification, getMomentAgoText } from 'services/resolvers/Common';
import * as React from 'react';
import AvatarWrapper from 'components/Common/AvatarWrapper';
import { TASKS_ROUTE_PREFIX } from 'routes/dashboardRoutes/TaskManagerRoutes';
import { JOB_ROUTE_PREFIX } from 'routes/dashboardRoutes/JobsRoutes';
import { COMPANY_ROUTE_PREFIX } from 'routes/dashboardRoutes/CompanyRoutes';
// import { useNavigate } from 'react-router-dom';

// styles
const ListItemWrapper = styled('div')(({ theme }) => ({
    cursor: 'pointer',
    padding: 16,
    '&:hover': {
        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
    },
    '& .MuiListItem-root': {
        padding: 0
    }
}));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const validTypeText: Record<string, string> = {
    Task: TASKS_ROUTE_PREFIX,
    JobRequisition: JOB_ROUTE_PREFIX,
    CompanyComment: COMPANY_ROUTE_PREFIX,
    TaskComment: TASKS_ROUTE_PREFIX,
    Comment: 'TODO'
};

const formatNotificationMessage = (notification: Notification) => {
    let message = notification.message;
    message = message.substring(0, message.indexOf(notification.modelType));

    const regex = /([a-z])([A-Z])/g;
    const separatedText = `${notification.modelType}`.replace(regex, '$1 $2');

    return `${message} a ${separatedText.toLocaleLowerCase()}`;
};

// ==============================|| NOTIFICATION LIST ITEM ||============================== //

export type NotificationListProps = {
    notificationList: Notification[];
    handleClose: () => void;
};

const NotificationList = ({ notificationList, handleClose }: NotificationListProps) => {
    const theme = useTheme();
    // const navigate = useNavigate();

    return (
        <List
            sx={{
                width: 330,
                maxWidth: 330,
                py: 0,
                borderRadius: '10px',
                [theme.breakpoints.down('md')]: {
                    maxWidth: 300
                },
                '& .MuiListItemSecondaryAction-root': {
                    top: 22
                },
                '& .MuiDivider-root': {
                    my: 0
                },
                '& .list-container': {
                    pl: 7
                }
            }}
        >
            {notificationList.map((notification, index) => (
                <React.Fragment key={`noti-${index}`}>
                    <ListItemWrapper
                        onClick={() => {
                            // navigate(`${validTypeText[notification.modelType]}/${notification.modelId}`);
                            handleClose();
                        }}
                    >
                        <ListItem alignItems="center">
                            <ListItemAvatar>
                                {notification.companyAvatar ? (
                                    <AvatarWrapper url={notification.companyAvatar} type="company" size="semi" />
                                ) : (
                                    <AvatarWrapper url={notification.createdByAvatar} type="user" size="semi" />
                                )}
                            </ListItemAvatar>
                            <ListItemText
                                sx={{
                                    maxWidth: '155px',
                                    wordWrap: 'break-word'
                                }}
                            >
                                {formatNotificationMessage(notification)}
                            </ListItemText>
                            <ListItemSecondaryAction>
                                <Grid container justifyContent="flex-end">
                                    <Grid item xs={12}>
                                        <Typography variant="caption" display="block" gutterBottom maxWidth={70}>
                                            {getMomentAgoText(notification.createdAt)}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </ListItemSecondaryAction>
                        </ListItem>
                        <Grid container direction="column" className="list-container">
                            <Grid item xs={12}>
                                <Typography variant="subtitle2" sx={{ wordWrap: 'break-word' }}>
                                    {notification.content}
                                </Typography>
                            </Grid>
                        </Grid>
                    </ListItemWrapper>
                    <Divider />
                </React.Fragment>
            ))}
        </List>
    );
};

export default NotificationList;
